import Tool, { type ToolArgs } from '../../../tools/Tool';
import { ReactEditor } from 'slate-react';
import { Transforms } from 'slate';
import { svgToIcon } from '../../../components/Toolbar/toolbarUtils';
import embedLinkSvg from '../../../assets/icons/embedLink.svg';
import embedIframeSvg from '../../../assets/icons/embedIframe.svg';
import { isEmbedElement } from '../../../types/guards';

class ToolEmbedDisplay extends Tool {
  static toolName = 'Display style';
  static embedDisplay: 'link' | 'frame';
  static iconSvg: any;

  static action({ editor, element }: ToolArgs): void {
    if (!element || !isEmbedElement(element)) return;

    const path = ReactEditor.findPath(editor, element);
    Transforms.setNodes(
      editor,
      { embed_display: this.embedDisplay },
      {
        at: path,
      }
    );
  }

  static isActive({ editor, element }: ToolArgs): boolean {
    return Boolean(
      element &&
        isEmbedElement(element) &&
        element.embed_display === this.embedDisplay
    );
  }

  static renderToolbarButtonIcon({ editor }: ToolArgs): JSX.Element {
    return svgToIcon(this.iconSvg);
  }
}

class ToolEmbedDisplayLink extends ToolEmbedDisplay {
  static toolName = 'Link';
  static iconSvg = embedLinkSvg;
  static embedDisplay: 'link' | 'frame' = 'link';
}

class ToolEmbedDisplayFrame extends ToolEmbedDisplay {
  static toolName = 'Embed';
  static iconSvg = embedIframeSvg;
  static embedDisplay: 'link' | 'frame' = 'frame';
}

export { ToolEmbedDisplayLink, ToolEmbedDisplayFrame };
